module.exports = __webpack_public_path__ + "static/media/munoz.ff84678b.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/ExampleCarousel/assets/munoz.png
// module id = 451
// module chunks = 0